module.exports = __webpack_public_path__ + "4dc99e6cf6da645eef101ff48493b43e.pdf";